import { useAlertsControllerGetAlerts } from '@/generated/api/alerts.ts';
import { WORK_ORDER_AUTO_REFRESH_QUERY_OPTIONS } from '../autoRefresh.ts';

export function useWorkOrderAlerts(workOrderId?: string) {
  return useAlertsControllerGetAlerts(
    { view: 'active', entityType: 'workOrder', entityId: workOrderId ?? '' },
    {
      query: {
        ...WORK_ORDER_AUTO_REFRESH_QUERY_OPTIONS,
        enabled: Boolean(workOrderId),
      },
    },
  );
}
